var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93014 2.48028L4.59014 5.44028C3.38014 6.11028 2.39014 7.79028 2.39014 9.17028V14.8203C2.39014 16.2003 3.38014 17.8803 4.59014 18.5503L9.93014 21.5203C11.0701 22.1503 12.9401 22.1503 14.0801 21.5203L19.4201 18.5503C20.6301 17.8803 21.6201 16.2003 21.6201 14.8203V9.17028C21.6201 7.79028 20.6301 6.11028 19.4201 5.44028L14.0801 2.47028C12.9301 1.84028 11.0701 1.84028 9.93014 2.48028Z",
    stroke: "#8C8F91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16992 7.43994L11.9999 12.5499L20.7699 7.46994",
    stroke: "#8C8F91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.61V12.54",
    stroke: "#8C8F91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuItems);
export default __webpack_public_path__ + "static/media/menu-items.dd241ac926516f73cb66e8b0c5894d8c.svg";
export { ForwardRef as ReactComponent };